import { Component } from "react";

/* The site-wide crash safety net (owner, 2026-11-04).

   Before this, an error thrown while rendering any part of the site reached
   no boundary, and React unmounted the whole app: a blank page (seen live
   with Soko's widget, fixed in #240). Now a crash shows a short message and
   a Reload button instead.

   Two places use it:
   - around each page (App.js, inside the shell), so the nav and footer stay
     and only the page area shows the message; moving to another page
     (a new `resetKey`) gives a fresh chance;
   - around the whole app (index.js), for a crash in the shell itself, where
     no nav can be shown.

   It NEVER reloads by itself: only the button reloads, so a page that
   crashes on every load cannot loop. */
export default class CrashBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { crashed: false };
  }

  static getDerivedStateFromError() {
    return { crashed: true };
  }

  componentDidUpdate(prevProps) {
    if (this.state.crashed && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ crashed: false });
    }
  }

  render() {
    if (!this.state.crashed) return this.props.children;
    return (
      <div role="alert" className="route-chunk-error">
        <p>Something went wrong.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
